import { AfterViewInit, ViewChild, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "src/app/shared/user.service";
import { NotificationService } from "../shared/notification.service";
import { Notification } from "../shared/notification.model";
import { ToastrService } from "ngx-toastr";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import * as moment from "moment";
import { DeleteDialogComponent } from "../../contract-master/delete-dialog/delete-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ContractTypeService } from "../../shared/contract-type.service";

@Component({
  selector: "app-notification-list",
  templateUrl: "./notification-list.component.html",
  styleUrls: ["./notification-list.component.css"],
})
export class NotificationListComponent implements AfterViewInit, OnInit {
  // Table columns
  displayedColumns: string[] = [
    "Notification Name",
    "Applied On",
    "Created By",
    "Last Updated",
    "Status",
    "Action",
  ];

  dataSource = new MatTableDataSource<Notification>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  isLoading: { [key: string]: boolean } = {};

  constructor(
    public userService: UserService,
    public notificationService: NotificationService,
    private contractTypeService: ContractTypeService,
    public router: Router,
    private toast: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getNotifications();
  }

  // Populating table data
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  openDeleteConfirmation(id): void {
    const dialogRef =
      this.dialog.open(DeleteDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        data: {
          deleteFunction: () => this.deleteNotification(id, dialogRef)
        }
      });
  }
  async getNotifications(notificationId = null) {
    try {
      await this.notificationService
        .getNotificationData()
        .then((notificationData: any) => {
          notificationData.forEach((notification: any) => {
            notification.updatedOn = notification.updatedOn ? moment(notification.updatedOn).format("lll") : null;
            notification.createdOn = moment(notification.createdOn).format("lll");
          });
          this.dataSource.data = notificationData;
        });
      this.isLoading[notificationId] = false;
    } catch (error) {
      this.toast.error('Something went wrong, Please try again later!', 'Error');
    }
  }


  async toggleNotificationStatus(id) {
    try {
      this.isLoading[id] = true;
      await this.notificationService.toggleNotificationStatus(id).then((res) => {
        this.toast.success('Notification status has been updated successfully!', '');
        this.getNotifications(id);
      })
    } catch (error) {
      this.toast.error('Notification cannot be updated!', 'Error');
    }
  }

  async deleteNotification(id: number, dialogRef: MatDialogRef<DeleteDialogComponent>) {
    try {
      await this.notificationService.deleteNotification(id);
      this.toast.success('The notification has been deleted successfully!', '');
      this.getNotifications();
      dialogRef.close();
    } catch (error) {
      this.toast.error('Failed to delete the Notification!', 'Error');
    }


    // let decision = window.confirm("Are you sure to delete?");

    // if (decision) {
    //   this.notificationService.deleteNotification(id).then((notificationId: number) => {
    //     this.dataSource.data = this.dataSource.data.filter((notification) => {
    //       return notificationId !== notification.notificationId;
    //     });
    //     this.toastr.success(
    //       "Notification has been deleted Successfully!!",
    //       "Notification Deleted"
    //     );
    //   });
    // }
  }
}
